import React from "react";
                  
export default function Referral() {
    return <h1>Hello!</h1>
}   